import { render, staticRenderFns } from "./Folders2.vue?vue&type=template&id=543eb7ea&scoped=true"
import script from "./Folders2.vue?vue&type=script&lang=js"
export * from "./Folders2.vue?vue&type=script&lang=js"
import style0 from "./Folders2.vue?vue&type=style&index=0&id=543eb7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543eb7ea",
  null
  
)

export default component.exports